import InvestigationStatusBadge from '@/components/shared/InvestigationStatusBadge'
import { colors } from '@/theme'
import type { Investigation } from '@/types/investigation'
import { Paper, Typography } from '@mui/material'

interface InvestigationHeaderProps {
  investigation: Investigation
}

export default function InvestigationHeader({ investigation }: InvestigationHeaderProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 3,
        border: `1px solid ${colors.border.default}`
      }}
    >
      <Typography variant='sectionTitle'>
        {investigation.name}
        {investigation.externalId ? ` - ${investigation.externalId}` : ''}
      </Typography>

      <InvestigationStatusBadge status={investigation.status} />
    </Paper>
  )
}
